export default {
  users: [],
  userInfos: {
    id: null,
    email: null,
    name: null,
    role: {
      id: null,
      name: null,
      name_pt_br: null
    },
    originalBearer: null,
    social_networks: {
      facebook: null,
      twitter: null,
      instagram: null
    }
  },
  isOriginalUser: true,
};
